<!-- Modal (Arquivos) -->

<ng-template #arquivos let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-arquivos"><b>Arquivos</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="text-center">
      <h5><b>Deseja adicionar arquivo(s) em anexo ao cadastro?</b></h5>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Nao')">Não</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Sim')">Sim</button>
  </div>
</ng-template>

<!-- Modal (E-mail) -->

<ng-template #email let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-email"><b>E-mail</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="text-center">
      <h5><b>Deseja enviar e-mail?</b></h5>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Nao')">Não</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Sim')">Sim</button>
  </div>
</ng-template>

<div class="container-fluid p-0">
  <!-- Título -->

  @if (!carregando) {
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4" [@esvanecerDesvanecer]="'in'">
      @if (cliente == null) {
        <div class="titulo_texto">Novo Cliente</div>
      }
      @if (cliente != null) {
        <div class="titulo_texto">Alterar Cliente</div>
      }
    </div>
  }

  @if (!carregando) {
    <div [@esvanecerDesvanecer]="'in'">
      <!-- Itens (Menu) -->
      <div class="pt-3 pr-4 pb-0 pl-4">
        <div class="d-flex flex-wrap justify-content-center itens_menu">
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 0) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(0)">
            1. Informações
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 1) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(1)">
            2. Endereço
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 2) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(2)">
            3. Contato
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 3) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(3)">
            4. Observações
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 4) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(4)">
            5. Dados Bancários
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 5) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(5)">
            6. Dados Comerciais
          </div>
          @if (cliente != null) {
            <div class="item_menu pt-2 pb-2 pl-3 mr-0" [ngClass]="(itemSelecionado == 6) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(6)">
              7. Arquivos
            </div>
          }
        </div>
        <hr class="mt-2 mb-2" />
      </div>
      <!-- Informações -->
      @if (itemSelecionado == 0) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <form [formGroup]="formClienteInformacoes">
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Razão Social:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="100" name="razao_social" [ngClass]="{ 'is-invalid': enviadoClienteInformacoes && fin.razao_social.errors?.required }" formControlName="razao_social" />
                @if (enviadoClienteInformacoes && fin.razao_social.errors?.required) {
                  <div class="erro pt-1">Razão Social em branco!</div>
                }
              </div>
              <div class="form-group col-sm-6">
                <label><b>Fantasia:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="100" name="fantasia" formControlName="fantasia" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-4">
                <label><b>CNPJ/CPF:{{ cnpjObrigatorio ? ' *' : '' }}</b></label>
                <div class="input-group input-group-sm">
                  <input class="form-control form-control-sm" type="text" maxlength="18" name="cnpj_cpf" [ngClass]="{ 'is-invalid': enviadoClienteInformacoes && (fin.cnpj_cpf.errors?.invalid || fin.cnpj_cpf.errors?.required) }" formControlName="cnpj_cpf" />
                  <div class="input-group-append">
                    <button class="btn btn-secondary" type="button" [disabled]="consultandoCnpj || formClienteInformacoes.controls['cnpj_cpf'].disabled" (click)="consultarCNPJHub()">
                      {{ consultandoCnpj ? 'Buscando...' : 'Buscar CNPJ' }}
                    </button>
                  </div>
                </div>
                @if (enviadoClienteInformacoes && fin.cnpj_cpf.errors?.required) {
                  <div class="erro pt-1">CNPJ/CPF obrigatório!</div>
                }
                @if (enviadoClienteInformacoes && fin.cnpj_cpf.errors?.invalid) {
                  <div class="erro pt-1">CNPJ/CPF inválido!</div>
                }
              </div>
              <div class="form-group col-sm-4">
                <label><b>IE:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="ie" formControlName="ie" [ngClass]="{ 'is-invalid': enviadoClienteInformacoes && fin.ie.errors?.required }" />
                @if (enviadoClienteInformacoes && fin.ie.errors?.required) {
                  <div class="erro pt-1">IE obrigatória!</div>
                }
              </div>
              <div class="form-group col-sm-4">
                <label><b>Segmento:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="100" name="segmento" formControlName="segmento" [ngClass]="{ 'is-invalid': enviadoClienteInformacoes && fin.segmento.errors?.required }" />
                @if (enviadoClienteInformacoes && fin.segmento.errors?.required) {
                  <div class="erro pt-1">Segmento obrigatório!</div>
                }
              </div>
            </div>
            @if (subsegmentos?.length > 0) {
              <div class="form-row">
                <div class="form-group col-sm-4">
                  <label><b>Subsegmento:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                  <select class="form-control form-control-sm" formControlName="subsegmento" [ngClass]="{ 'is-invalid': enviadoClienteInformacoes && fin.subsegmento.errors?.required }">
                    <option value="">-- Selecione --</option>
                    @for (s of subsegmentos; track s) {
                      <option [value]="s.nome_subsegmento">{{ s.nome_subsegmento }}</option>
                    }
                  </select>
                  @if (enviadoClienteInformacoes && fin.subsegmento.errors?.required) {
                    <div class="erro pt-1">Subsegmento obrigatório!</div>
                  }
                </div>
              </div>
            }
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label><b>Vendedor(a):</b></label>
                <select class="form-control form-control-sm" name="vendedor" #vendedor (change)="selecionarVendedor(vendedor.value)" [disabled]="cliente != null && !is_master && !clienteCadastroNovoErp">
                  @for (opcao of vendedores; track opcao) {
                    <option [value]="opcao.id" [selected]="vendedorSelecionado != null ? opcao.id == vendedorSelecionado.id : null">{{ opcao.fullname }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-3">
                <label><b>Dt. Cadastro:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="19" name="dt_cadastro" formControlName="dt_cadastro" />
              </div>
              @if (is_master || clienteCadastroNovoErp) {
                <div class="form-group col-sm-3">
                  <label><b>Status Financeiro:</b></label>
                  <input class="form-control form-control-sm" type="text" maxlength="300" name="status_financeiro" formControlName="status_financeiro" />
                </div>
              }
              <div class="form-group col-sm-3">
                <label><b>Objetivo:</b></label>
                <input class="form-control form-control-sm" type="number" name="objetivo" formControlName="objetivo" />
              </div>
              @if (is_master || clienteCadastroNovoErp) {
                <div class="form-group col-sm-3">
                  <label><b>Transportadora:</b></label>
                  <input class="form-control form-control-sm" type="text" maxlength="10" name="transportadora" formControlName="transportadora" />
                </div>
              }
            </div>
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label><b>Ativo:</b></label>
                <select class="form-control form-control-sm" name="ativo" #ativo (change)="selecionarAtivo(ativo.value)" [disabled]="!is_master && !clienteCadastroNovoErp">
                  <option value="0" [selected]="!clienteAtivo">Não</option>
                  <option value="1" [selected]="clienteAtivo">Sim</option>
                </select>
              </div>
            </div>
            <!-- Efetivo / Tipo de Loja / CNPJ Vinculado -->
            <div class="form-row">
              <div class="form-group col-sm-3">
                <label><b>Efetivo:</b></label>
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" id="chk_efetivo" formControlName="efetivo" (change)="onEfetivoChange()" />
                  <label class="form-check-label" for="chk_efetivo">Cliente Efetivo</label>
                </div>
              </div>
              <div class="form-group col-sm-3">
                <label><b>Tipo de Loja:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <select class="form-control form-control-sm" formControlName="tipo_loja" [ngClass]="{ 'is-invalid': enviadoClienteInformacoes && fin.tipo_loja.errors?.required }">
                  <option value="">-- Selecione --</option>
                  <option value="FISICA">Física</option>
                  <option value="ECOMMERCE">E-commerce</option>
                </select>
                @if (enviadoClienteInformacoes && fin.tipo_loja.errors?.required) {
                  <div class="erro pt-1">Tipo de Loja obrigatório!</div>
                }
              </div>
              <div class="form-group col-sm-3">
                <label><b>CNPJ Vinculado?</b></label>
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" id="chk_cnpj_vinculado_bit" formControlName="cnpj_vinculado_bit" (change)="onCnpjVinculadoBitChange()" />
                  <label class="form-check-label" for="chk_cnpj_vinculado_bit">Possui CNPJ Vinculado</label>
                </div>
              </div>
              @if (cnpjVinculadoBit) {
                <div class="form-group col-sm-3">
                  <label><b>CNPJ Vinculado:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                  <input class="form-control form-control-sm" type="text" maxlength="18" placeholder="XX.XXX.XXX/XXXX-XX" formControlName="cnpj_vinculado" [ngClass]="{ 'is-invalid': enviadoClienteInformacoes && (fin.cnpj_vinculado.errors?.required || fin.cnpj_vinculado.errors?.invalid) }" />
                  @if (enviadoClienteInformacoes && fin.cnpj_vinculado.errors?.required) {
                    <div class="erro pt-1">CNPJ Vinculado obrigatório!</div>
                  }
                  @if (enviadoClienteInformacoes && fin.cnpj_vinculado.errors?.invalid) {
                    <div class="erro pt-1">CNPJ Vinculado inválido!</div>
                  }
                </div>
              }
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <div class="d-flex justify-content-end">
            <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(0)">Prosseguir</button>
          </div>
        </div>
      }
      <!-- Endereço -->
      @if (itemSelecionado == 1) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <form [formGroup]="formClienteEndereco">
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label><b>Logradouro:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="100" name="logradouro" [ngClass]="{ 'is-invalid': enviadoClienteEndereco && fen.logradouro.errors?.required }" formControlName="logradouro" />
                @if (enviadoClienteEndereco && fen.logradouro.errors?.required) {
                  <div class="erro pt-1">Logradouro em branco!</div>
                }
              </div>
              <div class="form-group col-sm-8">
                <label><b>Endereço:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="150" name="endereco" [ngClass]="{ 'is-invalid': enviadoClienteEndereco && fen.endereco.errors?.required }" formControlName="endereco" />
                @if (enviadoClienteEndereco && fen.endereco.errors?.required) {
                  <div class="erro pt-1">Endereço em branco!</div>
                }
              </div>
              <div class="form-group col-sm-2">
                <label><b>Número:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="10" name="numero" [ngClass]="{ 'is-invalid': enviadoClienteEndereco && fen.numero.errors?.required }" formControlName="numero" />
                @if (enviadoClienteEndereco && fen.numero.errors?.required) {
                  <div class="erro pt-1">Número em branco!</div>
                }
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Complemento:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="40" name="complemento" [ngClass]="{ 'is-invalid': enviadoClienteEndereco && fen.complemento.errors?.required }" formControlName="complemento" />
                @if (enviadoClienteEndereco && fen.complemento.errors?.required) {
                  <div class="erro pt-1">Complemento em branco!</div>
                }
              </div>
              <div class="form-group col-sm-6">
                <label><b>Bairro:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="40" name="bairro" [ngClass]="{ 'is-invalid': enviadoClienteEndereco && fen.bairro.errors?.required }" formControlName="bairro" />
                @if (enviadoClienteEndereco && fen.bairro.errors?.required) {
                  <div class="erro pt-1">Bairro em branco!</div>
                }
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label><b>Estado:</b></label>
                <select class="form-control form-control-sm" name="estado" #estado (change)="selecionarEstado(estado.value)" [disabled]="!is_master && cliente != null && !clienteCadastroNovoErp">
                  @for (opcao of estados; track opcao) {
                    <option [value]="opcao.sigla_uf" [selected]="estadoSelecionado != null ? opcao.sigla_uf == estadoSelecionado.sigla_uf : null">{{ opcao.nome_uf }}</option>
                  }
                </select>
              </div>
              <div class="form-group col-sm-8">
                <label><b>Cidade:</b></label>
                <select class="form-control form-control-sm" name="cidade" #cidade (change)="selecionarCidade(cidade.value)" [disabled]="!is_master && cliente != null && !clienteCadastroNovoErp">
                  @for (opcao of cidades; track opcao) {
                    <option [value]="opcao.cod_ibge" [selected]="cidadeSelecionada != null ? opcao.cod_ibge == cidadeSelecionada.cod_ibge : null">{{ opcao.nome_cidade }}</option>
                  }
                </select>
              </div>
              <div class="form-group col-sm-2">
                <label><b>CEP:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="10" name="cep" [ngClass]="{ 'is-invalid': enviadoClienteEndereco && fen.cep.errors?.required }" formControlName="cep" />
                @if (enviadoClienteEndereco && fen.cep.errors?.required) {
                  <div class="erro pt-1">CEP em branco!</div>
                }
              </div>
            </div>
            <hr class="mt-2 mb-2" />
            <div class="subtitulo mb-2">Endereço p/ Entrega</div>
            <div class="form-row">
              <div class="form-group col-sm-10">
                <label><b>Endereço:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="150" name="entrega_endereco" formControlName="entrega_endereco" />
              </div>
              <div class="form-group col-sm-2">
                <label><b>Número:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="10" name="entrega_numero" formControlName="entrega_numero" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Complemento:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="40" name="entrega_complemento" formControlName="entrega_complemento" />
              </div>
              <div class="form-group col-sm-6">
                <label><b>Bairro:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="40" name="entrega_bairro" formControlName="entrega_bairro" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label><b>Estado:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="40" name="entrega_estado" formControlName="entrega_estado" />
              </div>
              <div class="form-group col-sm-10">
                <label><b>Cidade:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="100" name="entrega_cidade" formControlName="entrega_cidade" />
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(1)">Retornar</button>
            </div>
            <div class="flex-grow-1 formulario_rodape text-right">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(1)">Prosseguir</button>
            </div>
          </div>
        </div>
      }
      <!-- Contato -->
      @if (itemSelecionado == 2) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <form [formGroup]="formClienteContato">
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Responsável:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="100" name="responsavel" [ngClass]="{ 'is-invalid': enviadoClienteContato && fco.responsavel.errors?.required }" formControlName="responsavel" />
                @if (enviadoClienteContato && fco.responsavel.errors?.required) {
                  <div class="erro pt-1">Responsável em branco!</div>
                }
              </div>
              <div class="form-group col-sm-6">
                <label><b>Contato / Comprador:{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="100" name="contato" formControlName="contato" [ngClass]="{ 'is-invalid': enviadoClienteContato && fco.contato.errors?.required }" />
                @if (enviadoClienteContato && fco.contato.errors?.required) {
                  <div class="erro pt-1">Contato / Comprador obrigatório!</div>
                }
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label><b>Telefone: 1{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="telefone_1" [ngClass]="{ 'is-invalid': enviadoClienteContato && fco.telefone_1.errors?.required }" formControlName="telefone_1" />
                @if (enviadoClienteContato && fco.telefone_1.errors?.required) {
                  <div class="erro pt-1">Telefone 1 em branco!</div>
                }
              </div>
              <div class="form-group col-sm-2">
                <label><b>Telefone: 2</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="telefone_2" formControlName="telefone_2" />
              </div>
              <div class="form-group col-sm-2">
                <label><b>Telefone: 3</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="telefone_3" formControlName="telefone_3" />
              </div>
              <div class="form-group col-sm-3">
                <label>
                  <b>WhatsApp: (DDD)</b>
                  @if (callCenterConfiguracao.integrado_whatss && usa_whatsapp && cliente != null) {
                    <i class="fa fa-whatsapp label_acao ml-2" placement="top" ngbTooltip="Whatsapp" (click)="iniciarChat()"></i>
                    &nbsp;
                  }
                </label>
                <input class="form-control form-control-sm" type="text" maxlength="2" name="ddd_whatsapp" #ddd_whatsapp (input)="somenteNumeros(ddd_whatsapp)" [ngClass]="{ 'is-invalid': enviadoClienteContato && fco.ddd_whatsapp.errors?.required }" formControlName="ddd_whatsapp" />
              </div>
              <div class="form-group col-sm-3">
                <label>
                  <b>WhatsApp: (Telefone)</b>
                  @if (callCenterConfiguracao.integrado_whatss && usa_whatsapp && cliente != null) {
                    <i class="fa fa-whatsapp label_acao ml-2" placement="top" ngbTooltip="Whatsapp" (click)="iniciarChat()"></i>
                    &nbsp;
                  }
                </label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="telefone_whatsapp" #telefone_whatsapp (input)="somenteNumeros(telefone_whatsapp)" [ngClass]="{ 'is-invalid': enviadoClienteContato && fco.telefone_whatsapp.errors?.required }" formControlName="telefone_whatsapp" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>E-mail: 1{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="email_1" [ngClass]="{ 'is-invalid': enviadoClienteContato && fco.email_1.errors?.required }" formControlName="email_1" />
                @if (enviadoClienteContato && fco.email_1.errors?.required) {
                  <div class="erro pt-1">E-mail 1 em branco!</div>
                }
              </div>
              <div class="form-group col-sm-6">
                <label><b>E-mail: 2</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="email_2" formControlName="email_2" />
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(2)">Retornar</button>
            </div>
            <div class="flex-grow-1 formulario_rodape text-right">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(2)">Prosseguir</button>
            </div>
          </div>
        </div>
      }
      <!-- Observações -->
      @if (itemSelecionado == 3) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <form [formGroup]="formClienteObservacoes">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label><b>Observações:</b></label>
                <textarea class="form-control form-control-sm" rows="5" name="observacoes" formControlName="observacoes"></textarea>
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(3)">Retornar</button>
            </div>
            <div class="flex-grow-1 formulario_rodape text-right">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(3)">Prosseguir</button>
            </div>
          </div>
        </div>
      }
      <!-- Dados Bancários -->
      @if (itemSelecionado == 4) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <form [formGroup]="formClienteDadosBancarios">
            <div class="form-row">
              <div class="form-group col-sm-8">
                <label><b>Nome:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="30" name="nome" formControlName="nome" />
              </div>
              <div class="form-group col-sm-2">
                <label><b>Agência:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="10" name="agencia" formControlName="agencia" />
              </div>
              <div class="form-group col-sm-2">
                <label><b>Conta:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="10" name="conta" formControlName="conta" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-8">
                <label><b>Contato:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="contato" formControlName="contato" />
              </div>
              <div class="form-group col-sm-4">
                <label><b>Telefone:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="telefone" formControlName="telefone" />
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(4)">Retornar</button>
            </div>
            <div class="flex-grow-1 formulario_rodape text-right">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="prosseguirItemSelecionado(4)">Prosseguir</button>
            </div>
          </div>
        </div>
      }
      <!-- Dados Comerciais -->
      @if (itemSelecionado == 5) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <form [formGroup]="formClienteDadosComerciais">
            <!-- Referência 1 -->
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Referência: 1{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="referencia_1" formControlName="referencia_1" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_1.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_1.errors?.required) {
                  <div class="erro pt-1">Referência 1 obrigatória!</div>
                }
              </div>
              <div class="form-group col-sm-2">
                <label><b>Telefone: 1{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="referencia_telefone_1" formControlName="referencia_telefone_1" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_telefone_1.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_telefone_1.errors?.required) {
                  <div class="erro pt-1">Telefone obrigatório!</div>
                }
              </div>
              <div class="form-group col-sm-4">
                <label><b>Contato: 1{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="referencia_contato_1" formControlName="referencia_contato_1" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_contato_1.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_contato_1.errors?.required) {
                  <div class="erro pt-1">Contato obrigatório!</div>
                }
              </div>
            </div>
            <!-- Referência 2 -->
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Referência: 2{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="referencia_2" formControlName="referencia_2" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_2.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_2.errors?.required) {
                  <div class="erro pt-1">Referência 2 obrigatória!</div>
                }
              </div>
              <div class="form-group col-sm-2">
                <label><b>Telefone: 2{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="referencia_telefone_2" formControlName="referencia_telefone_2" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_telefone_2.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_telefone_2.errors?.required) {
                  <div class="erro pt-1">Telefone obrigatório!</div>
                }
              </div>
              <div class="form-group col-sm-4">
                <label><b>Contato: 2{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="referencia_contato_2" formControlName="referencia_contato_2" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_contato_2.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_contato_2.errors?.required) {
                  <div class="erro pt-1">Contato obrigatório!</div>
                }
              </div>
            </div>
            <!-- Referência 3 -->
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Referência: 3{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="referencia_3" formControlName="referencia_3" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_3.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_3.errors?.required) {
                  <div class="erro pt-1">Referência 3 obrigatória!</div>
                }
              </div>
              <div class="form-group col-sm-2">
                <label><b>Telefone: 3{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="20" name="referencia_telefone_3" formControlName="referencia_telefone_3" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_telefone_3.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_telefone_3.errors?.required) {
                  <div class="erro pt-1">Telefone obrigatório!</div>
                }
              </div>
              <div class="form-group col-sm-4">
                <label><b>Contato: 3{{ clienteEfetivo ? ' *' : '' }}</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="referencia_contato_3" formControlName="referencia_contato_3" [ngClass]="{ 'is-invalid': enviadoClienteDadosComerciais && fdc.referencia_contato_3.errors?.required }" />
                @if (enviadoClienteDadosComerciais && fdc.referencia_contato_3.errors?.required) {
                  <div class="erro pt-1">Contato obrigatório!</div>
                }
              </div>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 formulario_rodape">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(5)">Retornar</button>
            </div>
            <div class="flex-grow-1 text-right">
              <button class="btn btn-success btn_formulario" type="button" (click)="salvar()">Salvar</button>
            </div>
          </div>
        </div>
      }
      <!-- Arquivos -->
      @if (itemSelecionado == 6 && cliente != null) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <!-- Upload -->
          <form [formGroup]="formClienteArquivos">
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Descrição:</b></label>
                <input class="form-control form-control-sm" type="text" maxlength="50" name="descricao" [ngClass]="{ 'is-invalid': enviadoClienteArquivos && fca.descricao.errors?.required }" formControlName="descricao" />
                @if (enviadoClienteArquivos && fca.descricao.errors?.required) {
                  <div class="erro pt-1">Descrição em branco!</div>
                }
              </div>
              <div class="form-group col-sm-6">
                <label><b>Selecionar Arquivo:</b></label>
                <input class="form-control form-control-sm" type="file" accept="image/*, .pdf" [ngClass]="{ 'is-invalid': enviadoClienteArquivos && (fca.arquivo.errors?.required || fca.arquivo.errors?.invalid) }" formControlName="arquivo" #arquivo />
                <div class="mensagem pt-1">* Extensões PNG/JPG/JPEG/PDF</div>
                @if (enviadoClienteArquivos && fca.arquivo.errors?.required) {
                  <div class="erro pt-1">Arquivo em branco!</div>
                }
                @if (enviadoClienteArquivos && fca.arquivo.errors?.invalid) {
                  <div class="erro pt-1">Arquivo inválido!</div>
                }
              </div>
            </div>
            <hr class="mt-2 mb-2" />
            <div class="d-flex justify-content-end">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="adicionarArquivo()">Adicionar Arquivo</button>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <!-- Arquivos Anexos -->
          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th class="tabela_borda"></th>
                  <th class="text-center tabela_borda">Data</th>
                  <th class="tabela_borda">Descrição</th>
                </tr>
              </thead>
              <tbody>
                @for (clienteArquivo of clienteArquivos; track clienteArquivo) {
                  <tr>
                    <td class="text-center tabela_acao">
                      <i class="fa fa-download btn_tabela_acao" placement="right" ngbTooltip="Abrir" (click)="abrirArquivo(clienteArquivo.nm_arquivo)"></i>
                    </td>
                    <td class="text-center tabela_acao tabela_borda">
                      <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Excluir" (click)="deletarArquivo(clienteArquivo.id, clienteArquivo.nm_arquivo)"></i>
                    </td>
                    <td class="text-center tabela_borda">{{ clienteArquivo.dt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td class="tabela_borda">{{ clienteArquivo.descricao }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <hr class="mt-2 mb-2" />
          <div class="d-flex flex-wrap justify-content-between">
            <div class="flex-grow-1 rodape_conteudo_esquerda">
              <button class="btn btn-secondary btn_formulario ml-0" type="button" (click)="retornarItemSelecionado(6)">Retornar</button>
            </div>
            <div class="flex-grow-1 text-right">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="enviarEmail()">Enviar E-mail</button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
